if (window.Maximize.checkFileNotLoaded()) {
  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xPromotionalCollections', (sectionId, defaultViewAllLink) => ({
        sectionId: sectionId,
        currentTab: 1,
        loading: true,
        loaded: [],
        view_all_link: defaultViewAllLink,
        productsWrapperEl: null,
        init() {
          this.productsWrapperEl = document.getElementById(`PromotionalCollectionsProducts--${sectionId}`);
        },
        selectCollection(index, viewAllLink) {
          this.currentTab = index;
          this.view_all_link = viewAllLink;
        },
        async loadDataCollection(index) {
          if (this.loaded.includes(index)) return;

          this.loading = true;
          let url = `${window.location.pathname}?section_id=${this.sectionId}&page=${index}`;

          const handleFetchData = async () => {
            fetch(url, {
              method: 'GET'
            }).then(
                response => response.text()
            ).then(responseText => {
              const html = (new DOMParser()).parseFromString(responseText, 'text/html');
              const contentId = `PromotionalCollections__${this.sectionId}__${index}`;
              const newContent = html.getElementById(contentId);
              if (newContent && !document.getElementById(contentId) && this.productsWrapperEl) {
                this.productsWrapperEl.appendChild(newContent);
                this.loaded.push(index);
                document.dispatchEvent(new CustomEvent(`${ANIMATION_EVENT.revealItem}`));
                this.loading = false;
              }
            })
          }
          
          await handleFetchData();

          if (Shopify.designMode && this.loading) {
            let count = 0;
            const interval = setInterval( async () => {
              ++count;
              if (count <= 20 && this.loading) {
                await handleFetchData();
                if (!this.loading) {
                  clearInterval(interval);
                }
              } else {
                clearInterval(interval);
                this.loading = false;
              }
            }, 300)
          }
        }
      }));
    });
  });
}
